import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { ColdHubPageData } from '@/types/dashboard/ColdHubPage';

type GetColdHubPageResponse = {
  value: ColdHubPageData;
};

type ColdHubPageQueryType = {
  cliente: string;
};

export const getDashboardColdHubPageData = async (
  query: ColdHubPageQueryType
): Promise<ColdHubPageData> => {
  try {
    const res = await apiClient.post<GetColdHubPageResponse>(
      Endpoints.DashboardColdHubPage,
      query
    );
    return res.data.value || {};
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
